import $http from "@/api/index";
import { getToken } from "../helpers/auth";
/**
 * 新流程实例
 * @param {*} isNew 是否是新发起的实例
 * @param {*} processId 流程实例ID
 * @param {*} schemeCode 流程模板编码
 * @param {*} processName 流程实例名称
 * @param {*} processLevel 流程重要等级
 * @param {*} description 备注说明
 * @param {*} auditers 下一个环节审批人
 * @param {*} currentNode 当前节点
 * @param {*} formData  表单数据
 * @param {*} isFinished  流程是否结束
 */
export function Flow(
  isNew,
  processId,
  schemeCode,
  processName,
  processLevel,
  description,
  auditers,
  currentNode,
  formData,
  isFinished = false,
  isEdit = false
) {
  let user = getToken();
  let getUrl = {
    method: "POST",
    url: `/WfEngine/Flow?isNew=${isNew}&processId=${processId}&schemeCode=${schemeCode}&processName=${user.realName +
      "提交了" +
      processName}&processLevel=${processLevel}&description=${description}&auditers=${auditers}&currentNode=${currentNode}&formData=${formData}&createUser=${JSON.stringify(
      user
    )}&isFinished=${isFinished}&isEdit=${isEdit}`,
    requestType: 1
  };
  let para = {};
  return $http(getUrl, para);
}

/**
 * 新流程审批实例
 * @param {*} isNew 是否是新发起的实例
 * @param {*} processId 流程实例ID
 * @param {*} schemeCode 流程模板编码
 * @param {*} processName 流程实例名称
 * @param {*} processLevel 流程重要等级
 * @param {*} description 备注说明
 * @param {*} auditers 下一个环节审批人
 * @param {*} currentNode 当前节点
 * @param {*} formData  表单数据
 */
export function AuditFlow(
  taskId,
  processId,
  verifyType,
  description,
  auditorId,
  auditorName,
  auditers,
  currentNode,
  formData
) {
  let user = getToken();
  let getUrl = {
    method: "POST",
    url: `/WfEngine/AuditFlow?taskId=${taskId}&processId=${processId}&verifyType=${verifyType}&auditorName=${auditorName}&auditorId=${auditorId}&description=${description}&auditers=${auditers}&currentNode=${currentNode}&formData=${formData}&currentUser=${JSON.stringify(
      user
    )}`,
    requestType: 1
  };
  let para = {};
  return $http(getUrl, para);
}

/**
 * 新流程审批实例
 * @param {*} isNew 是否是新发起的实例
 * @param {*} processId 流程实例ID
 * @param {*} schemeCode 流程模板编码
 * @param {*} processName 流程实例名称
 * @param {*} processLevel 流程重要等级
 * @param {*} description 备注说明
 * @param {*} auditers 下一个环节审批人
 * @param {*} currentNode 当前节点
 * @param {*} formData  表单数据
 * @param {*} isFinished  流程是否结束
 */
export function NewAuditFlow(
  taskId,
  processId,
  verifyType,
  description,
  auditers,
  currentNode,
  formData,
  isFinished
) {
  let user = getToken();
  if (!isFinished) {
    isFinished = false;
  }
  let getUrl = {
    method: "POST",
    url: `/WfEngine/NewAuditFlow?taskId=${taskId}&processId=${processId}&verifyType=${verifyType}&isFinished=${isFinished}&description=${description}&auditers=${auditers}&currentNode=${currentNode}&formData=${formData}&currentUser=${JSON.stringify(
      user
    )}`,
    requestType: 1
  };
  let para = {};
  return $http(getUrl, para);
}
